var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "reservation-event-modal" } },
    [
      _c(
        "a-modal",
        {
          attrs: {
            visible: true,
            cancelText: "Vazgeç",
            okText: "Kaydet",
            centered: "",
            footer: null,
          },
          on: {
            cancel: function ($event) {
              return _vm.$emit("close")
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "container" },
            [
              _c("div", { staticClass: "label-container" }, [
                _c("span", { staticClass: "material-icons icon" }, [
                  _vm._v("calendar_month"),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "label" }, [_vm._v("Reservation")]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "title", staticStyle: { "font-size": "17px" } },
                [_vm._v(_vm._s(_vm.reservationDetail.title))]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.getDate())),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "duration-container" }, [
                _c("span", { staticClass: "material-icons icon" }, [
                  _vm._v("timelapse"),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "duration" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm.reservationDetail.duration) +
                      " min appointments "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "SupsisButton",
                {
                  staticClass: "go-link",
                  on: {
                    click: function ($event) {
                      return _vm.goLink()
                    },
                  },
                },
                [
                  _c("span", { staticClass: "material-icons icon" }, [
                    _vm._v("open_in_new"),
                  ]),
                  _vm._v("\n                Linke Git\n            "),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "form" }, [
                _c("div", { staticClass: "material-icons icon" }, [
                  _vm._v("format_list_bulleted"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "right" }, [
                  _c("div", { staticClass: "form-title" }, [
                    _vm._v("Booking form"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "items" },
                    _vm._l(_vm.eventDetail.formValues, function (formInput, i) {
                      return _c("div", { staticClass: "item" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v(_vm._s(formInput.label + ": ")),
                        ]),
                        _vm._v(
                          "\n                            " +
                            _vm._s(formInput.value) +
                            "\n                        "
                        ),
                      ])
                    }),
                    0
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "buttons" },
                [
                  _c(
                    "SupsisButton",
                    {
                      staticClass: "button edit",
                      on: {
                        click: function ($event) {
                          return _vm.editReservation()
                        },
                      },
                    },
                    [_vm._v("Düzenle")]
                  ),
                  _vm._v(" "),
                  _vm.isDeletable()
                    ? _c(
                        "SupsisButton",
                        {
                          staticClass: "button edit",
                          on: {
                            click: function ($event) {
                              return _vm.deleteEvent()
                            },
                          },
                        },
                        [_vm._v("Sil")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }